"use client";

import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { SafeArea, SystemBarsStyle, SystemBarsType } from "@capacitor-community/safe-area";
import { initSentry } from "@/lib/observability/sentry";
import { initPostHog, captureAppOpen } from "@/lib/observability/posthog";

let initialized = false;

export async function initCapacitor() {
  if (initialized || !Capacitor.isNativePlatform()) return;
  initialized = true;

  // Crash reporting first, so a failure in any later boot step is captured.
  try {
    initSentry();
  } catch {
    // Never let crash-reporter setup break app boot.
  }

  try {
    initPostHog();
  } catch { /* non-critical */ }

  try {
    captureAppOpen();
    CapacitorApp.addListener("appStateChange", ({ isActive }) => {
      if (isActive) captureAppOpen();
    });
  } catch { /* non-critical */ }

  try {
    // Edge-to-edge (see MainActivity.EdgeToEdge.enable): the system bars are
    // transparent and the WebView paints under them, so env(safe-area-inset-*)
    // is consistent across iOS and Android. We draw our own brand-green strip
    // behind the status bar in CSS (see (main)/layout.tsx), and that strip is
    // dark — so the bar CONTENT (icons/clock) must be light. In this plugin's
    // vocabulary that is the "DARK" style ("light content on a dark background").
    await SafeArea.setSystemBarsStyle({ style: SystemBarsStyle.Dark, type: SystemBarsType.StatusBar });
    // The bottom navigation bar sits over the light beige tab bar, so its content
    // (gesture pill / 3-button icons) must be dark → the "LIGHT" style here.
    await SafeArea.setSystemBarsStyle({ style: SystemBarsStyle.Light, type: SystemBarsType.NavigationBar });
  } catch {
    // SafeArea may be unavailable in some environments — non-critical.
  }

  try {
    await SplashScreen.hide();
  } catch {
    // SplashScreen.hide is idempotent — non-critical
  }
}
